import { ArrowLeft, CheckCircle2, Users, Award, MapPin, Zap } from "lucide-react";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";

const PadmabatiMandap = () => {
  const navigate = useNavigate();

  return (
    <div className="lp-page">
      {/* Header */}
         {/* Navigation */}
      <nav className="nav-bar" data-testid="main-navigation">
        <div className="nav-container">
          <div className="nav-logo" data-testid="company-logo">
            <img src={require('src/images/MarutiGroupLogo.jpg')} alt="Maruti Group Logo" className="w-10 h-10" />
            <span className="logo-text">MARUTI GROUP</span>
          </div>
          </div>
          </nav>
      <div className="lp-header">
        <div className="container">
          <Button
            variant="ghost"
            onClick={() => navigate("/")}
            className="back-btn"
            data-testid="back-to-home-btn"
          >
            <ArrowLeft className="mr-2 w-5 h-5" />
            Back to Home
          </Button>
        </div>
      </div>

      {/* Hero Section */}
      <section className="lp-hero" data-testid="lp-hero-section">
        <div className="lp-hero-content">
          <div className="lp-hero-text">
            <div className="orange-accent"></div>
            <h1 className="lp-title" data-testid="lp-title">
              Core Ventures
            </h1>
            <div className="lp-subtitle-box">
              <h2 className="lp-subtitle">Padmabati Mandap</h2>
            </div>
            <p className="lp-description" data-testid="lp-description">
              Padmabati Mandap is a premium event venue designed to host weddings, celebrations, corporate functions, and special occasions. With world-class amenities and versatile event spaces, we create unforgettable memories for every celebration.
            </p>
          </div>
          <div className="lp-hero-image">
            <div className="blue-circle"></div>
            <img 
                src={require('src/images/Padmabati4.jpg')}
              alt="Padmabati Mandap Venue"
              className="building-image"
            />
          </div>
        </div>
      </section>

      {/* Venue Highlights Section */}
      <section className="lp-plotting" data-testid="lp-plotting-section">
        <div className="lp-plotting-content">
          <div className="lp-plotting-image">
            <img 
              src={require('src/images/Padmabati1.jpg')}
              alt="Premium Amenities"
            />
          </div>
          <div className="lp-plotting-text">
            <div className="orange-bar"></div>
            <h2 className="lp-section-title orange-text" data-testid="plotting-title">
              Premium Venue Facilities:
            </h2>
            <p className="lp-section-description" data-testid="plotting-description">
              Our state-of-the-art event venue is equipped with world-class amenities including spacious halls, modern kitchen facilities, parking accommodations, and elegant decorative spaces. We cater to events of all sizes and types, ensuring every celebration is memorable and seamlessly executed.
            </p>
            <div className="location-markers">
              <div className="location-item">
                <MapPin className="w-5 h-5 text-orange-600" />
                <span>Accessible and Prime Location</span>
              </div>
              <div className="location-item">
                <Zap className="w-5 h-5 text-orange-600" />
                <span>Modern Facilities & Infrastructure</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Event Capabilities Section */}
      <section className="lp-residential" data-testid="lp-residential-section">
        <div className="lp-residential-content">
          <div className="lp-residential-image">
            <img 
              src={require('src/images/Padmabati3.jpg')}
              alt="Event Capabilities"
            />
            <div className="orange-border-left"></div>
          </div>
          <div className="lp-residential-text">
            <h2 className="lp-section-title orange-text" data-testid="residential-title">
              Versatile Event Spaces:
            </h2>
            <p className="lp-section-description" data-testid="residential-description">
              From intimate gatherings to large-scale celebrations, Padmabati Mandap offers flexible event spaces that can be customized for weddings, receptions, corporate conferences, birthday parties, and cultural events. Our professional team ensures flawless execution of every detail.
            </p>

            <div className="divider"></div>

            <h3 className="lp-subsection-title orange-text" data-testid="experience-title">
              Complete Event Solutions
            </h3>
            <p className="lp-section-description" data-testid="experience-description">
              With experienced event management professionals and comprehensive support services, we handle everything from planning to execution, allowing you to focus on enjoying your special moment with loved ones.
            </p>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="lp-stats" data-testid="lp-stats-section">
        <div className="container">
          <h2 className="section-title" data-testid="stats-title">Our Excellence</h2>
          <div className="lp-stats-grid">
            <div className="lp-stat-card" data-testid="stat-card-0">
              <Users className="stat-icon" />
              <div className="stat-value">500+</div>
              <div className="stat-label">Successful Events</div>
            </div>
            <div className="lp-stat-card" data-testid="stat-card-1">
              <MapPin className="stat-icon" />
              <div className="stat-value">10K+</div>
              <div className="stat-label">Guest Capacity</div>
            </div>
            <div className="lp-stat-card" data-testid="stat-card-2">
              <Award className="stat-icon" />
              <div className="stat-value">100%</div>
              <div className="stat-label">Client Satisfaction</div>
            </div>
            <div className="lp-stat-card" data-testid="stat-card-3">
              <Zap className="stat-icon" />
              <div className="stat-value">15+</div>
              <div className="stat-label">Years in Business</div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="lp-features" data-testid="lp-features-section">
        <div className="container">
          <h2 className="section-title" data-testid="features-title">Why Choose Padmabati Mandap?</h2>
          <div className="lp-features-grid">
            <div className="lp-feature-card" data-testid="feature-card-0">
              <CheckCircle2 className="w-8 h-8 text-orange-600" />
              <h3>Premium Facilities</h3>
              <p>State-of-the-art amenities with elegant decor and modern infrastructure</p>
            </div>
            <div className="lp-feature-card" data-testid="feature-card-1">
              <CheckCircle2 className="w-8 h-8 text-orange-600" />
              <h3>Versatile Spaces</h3>
              <p>Customizable halls suitable for weddings, conferences, and celebrations</p>
            </div>
            <div className="lp-feature-card" data-testid="feature-card-2">
              <CheckCircle2 className="w-8 h-8 text-orange-600" />
              <h3>Professional Team</h3>
              <p>Experienced event managers dedicated to flawless execution</p>
            </div>
            <div className="lp-feature-card" data-testid="feature-card-3">
              <CheckCircle2 className="w-8 h-8 text-orange-600" />
              <h3>Prime Location</h3>
              <p>Conveniently located with excellent accessibility and parking</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="lp-cta" data-testid="lp-cta-section">
        <div className="container">
          <div className="lp-cta-content">
            <h2 data-testid="cta-title">Plan Your Perfect Event</h2>
            <p data-testid="cta-description">Contact us today to book Padmabati Mandap for your special celebration</p>
            <Button 
              size="lg" 
              className="cta-btn"
              onClick={() => navigate("/#contact")}
              data-testid="cta-contact-btn"
            >
              Get in Touch
            </Button>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="footer" data-testid="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <img src={require('src/images/MarutiGroupLogo.jpg')} alt="Maruti Group Logo" className="w-10 h-10" />
              <span>MARUTI GROUP</span>
            </div>
            <p className="footer-text">
              Building sustainable futures since 1987. Committed to quality, innovation, and customer satisfaction.
            </p>
          </div>
          <div className="footer-bottom">
            <p>© 2025 Maruti Group. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PadmabatiMandap;
